import {
    getSc,
    getScList,
    getScListRecommend,
} from "../apis/api_sc.js";

import { listMode } from '../utils/table';

const state = {
    filters: { mode: listMode.list },
    filtersPage: { mode: listMode.page },
    totalCount: 0,
    items: [],
    item: {},    
};

const getters = {
};

const mutations = {
    SET_SC_LIST(state, data){
        state.items = data.content;
        state.totalCount = data.totalElements;
    },

    SET_SC_LIST_PAGE(state, data) {
        data.content.forEach( (item) => {
            state.items.push(item);
        })
        if(state.totalCount != data.totalElements)
            state.totalCount = data.totalElements;
    },

    SET_SC(state, payload) {
        state.item = payload
    },

    CLEAR_SC(state) {
        state.item = {};
    },
    CLEAR_SC_LIST(state) {
        state.items = [];
        state.totalCount = 0;
    },
};

const actions = {

    async GET_SC({ commit }, id) {
        try {
            const response = await getSc(id);
            commit('SET_SC', response.data.data)
            return response.data.data;
        } catch (e) {
            return Promise.reject(e);
        }
    },    

    async GET_SC_LIST({ state, commit }, params = {} ) {
        let filters = { ...state.filters, ...params };
        try {
            const response = await getScList(filters);
            commit('SET_SC_LIST', response.data.data)
            return response.data.data;
        } catch (e) {
            return Promise.reject(e);
        }
    },

    async GET_SC_LIST_PAGE({ state, commit }, params = {} ) {
        let filters = { ...state.filtersPage, ...params };
        try {
            const response = await getScList(filters);
            commit('SET_SC_LIST_PAGE', response.data.data)
            return response.data.data;
        } catch (e) {
            return Promise.reject(e);
        }
    },

    async GET_SC_LIST_RECOMMEND({ commit }, params = {} ) {
        let filters = { ...params };
        try {
            const response = await getScListRecommend(filters);
            commit('SET_SC_LIST', response.data.data)
            return response.data.data;
        } catch (e) {
            return Promise.reject(e);
        }
    },


};

export default {mutations, state, actions, getters};